import { NgModule } from "@angular/core";

import { ProgressComponent } from "./progress.component";

@NgModule({
  imports: [ProgressComponent],
  exports: [ProgressComponent],
})
export class ProgressModule {}
